import { useState } from 'react';
import { Layout } from '@/components/Layout';
import { GenerateTab } from '@/features/generate/GenerateTab';
import { HistoryTab } from '@/features/history/HistoryTab';
import { FavoritesTab } from '@/features/favorites/FavoritesTab';
import { SettingsTab } from '@/features/settings/SettingsTab';
import type { Tab } from '@/shared/types';

function App(): JSX.Element {
  const [activeTab, setActiveTab] = useState<Tab>('generate');

  return (
    <Layout activeTab={activeTab} onTabChange={setActiveTab}>
      {activeTab === 'generate' && <GenerateTab />}
      {activeTab === 'history' && <HistoryTab />}
      {activeTab === 'favorites' && <FavoritesTab />}
      {activeTab === 'settings' && <SettingsTab />}
    </Layout>
  );
}

export default App;
